// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import {sync} from 'vuex-router-sync'
import routes from './routes'
import store from './store'
import VueMoment from 'vue-moment'
import VueTouch from 'vue-touch'
import "@fontsource/noto-sans-jp" // Defaults to weight 400
// import VueLocalStorage from 'vue-localstorage'
import {MediaQueries} from './service/Vendor/vue-media-queries'
import setting from './setting.js'
import downloadCsv from './service/vue-csv-download'
import API from './api.js'
import UUID from 'vue-uuid'
import ls from './ls'
import http from './http'
import 'allsettled-polyfill'
import Sugar from 'sugar'
import moment from 'moment/src/moment'
//Import Mixpanel SDK
import mixpanel from "mixpanel-browser"
import * as Sentry from "@sentry/vue"
import Swal from 'sweetalert2'

// Near entry of your product, init Mixpanel
mixpanel.init("be64964deb84481cdbafeb4cb208b572", {
    api_host: 'https://mp.bacs.ooo',
    debug: !import.meta.env.PROD,
    persistence: "localStorage",
    ignore_dnt: true,
    autocapture: {
        pageview: false,
        input: false,
        submit: true,
        click: false,
        scroll: false
    },
})

window.moment = moment
Vue.use(VueRouter)
Vue.use(VueMoment, {
    moment: moment
})
Vue.use(VueTouch, {name: 'v-touch'})

Sugar.extend()

// Vue.use(VueLocalStorage)
Vue.use(downloadCsv)

const router = new VueRouter({
    mode: 'history',
    routes
})

sync(store, router)

Vue.prototype.$alert = (txt) => {
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer
            toast.onmouseleave = Swal.resumeTimer
        }
    })
    Toast.fire({
        icon: "info",
        title: txt
    })
}

Vue.prototype.$confirm = (txt, confirmCb, deniedCb) => {
    Swal.fire({
        text: txt,
        showDenyButton: true,
        confirmButtonText: i18n.tc('yes'),
        confirmButtonColor: 'black',
        denyButtonText: i18n.tc('non'),
        denyButtonColor: 'gray',
        customClass: {
            actions: 'my-actions',
            cancelButton: 'order-1 right-gap',
            confirmButton: 'order-2',
            denyButton: 'order-3',
        },
    }).then((result) => {
        if (result.isConfirmed) {
            if (typeof confirmCb === 'function') {
                confirmCb()
            }
        } else if (result.isDenied) {
            if (typeof deniedCb === 'function') {
                deniedCb()
            }
        }
    })
}


Vue.prototype.$ls = ls

router.beforeEach((to, from, next) => {
    store.dispatch('changeInvalidScroll', {
        flg: false
    })
    // authFlag：tokenがあり、かつ期限内でtrue
    let authFlag = false
    let userAccount = ls.get('userAccount')
    let token = null
    let tokenExpireDate = null
    if (userAccount !== null) {
        token = userAccount.token_id
        tokenExpireDate = userAccount.token_expire
    }
    if (token !== null) {
        if (new Date(tokenExpireDate).getTime() > new Date().getTime()) {
            authFlag = true
        }
    }
    // to.matched.some(record => record.meta.requiresAuth) はroutes.jsのrequiresAuthがtrueかどうか
    if (!to.matched.some(record => record.meta.requiresAuth)) {
        // Auth不要ページ。そのまま表示（主にログアウト時）
        next()
    } else if (!authFlag) {
        // Auth必要ページかつtokenなし、もしくは有効期限切れ。ログイン画面へ
        next({path: '/', query: {redirect: to.fullPath}})
    } else {
        // Auth必要ページかつtokenあり、有効期限内。tokenの有効期限を更新して次のページへ
        API.TOKENS.patchTokens((json) => {
            // console.log('token Patch成功')
            userAccount.token_expire = json.expire
            ls.set('userAccount', userAccount)
            next()
        }, function (json) {
            next({path: '/', query: {redirect: to.fullPath}})
        })
    }
})

router.afterEach(to => {
    mixpanel.track_pageview({
        page: to.path,
        title: document.title
    })
})

const mediaQueries = new MediaQueries()
Vue.use(mediaQueries)

Vue.use(UUID)

Vue.prototype.$http = http

Vue.prototype.$copy = (obj) => {
    return JSON.parse(JSON.stringify(obj))
}

Vue.prototype.$p = {
    get(teamId) {
        return ls.get(teamId, {})
    },
    set(teamId, value) {
        ls.set(teamId, value)
    }
}

Vue.prototype.$user = (user) => {
    mixpanel.identify(user.identifier)
    mixpanel.people.set_once({
        '$name': user.name,
        '$email': user.email,
        'Team': user.additional?.my_team,
        'Name Kana': user.additional?.name_kana
    })
}

Vue.prototype.$d = (str) => {
    if (!str) {
        return window.moment()
    }
    if (Array.isArray(str)) {
        return null
    }
    if (typeof str.replace !== 'function') {
        return null
    }
    str = str.replace(/\[(HE|TM)\]/g, '')
    if (str.includes('/')) {
        const s = str.split('/')
        return window.moment([Math.trunc(s[2]), Math.trunc(s[0])-1, Math.trunc(s[1])])
    }
    if (str.includes('年')) {
        const st = str.replace(/[年/月]/g, '-').replace(/日/g, '')
        return window.moment(st)
    }
    return window.moment(str)
}

window.addEventListener('load', () => {
    checkPlatform()
    checkOrientation()
    window.addEventListener('resize', checkOrientation, false)
}, false)

function checkPlatform() {
    let ua = window.navigator.userAgent
    let platform = 'other'
    if (/iPhone/i.test(ua) ) {
        platform = 'iPhone'
    } else if (/ipad/i.test(ua) || /mac/i.test(ua) && window.navigator.maxTouchPoints > 0) {

        platform = 'iPad'
    } else if (/Android/i.test(ua)) {
        platform = 'Android'
    }
    console.log(platform)
    store.dispatch('changePlatform', {
        platform: platform
    })
}

function checkOrientation() {
    let angle = null
    if ('object' === typeof window.screen && 'object' === typeof window.screen.orientation) {
        angle = window.screen.orientation.type.replace('-primary', '')
    } else {
        if (window.innerHeight > window.innerWidth) {
            angle = 'portrait'
        } else {
            angle = 'landscape'
        }
    }
    console.log(angle)
    store.dispatch('changeOrientation', {
        rotate: angle
    })
}

Sentry.init({
    Vue,
    dsn: "https://96eb5099bdd5a6916fdf8c065e8fc4fa@o4509107229491200.ingest.us.sentry.io/4509116834840576"
})

new Vue({
    router,
    store,
    downloadCsv,
    render: h => h(App),
    mediaQueries: mediaQueries,
    localStorage: {
        savedBalls: {
            type: Array,
            default: []
        },
        savedStandardBalls: {
            type: Array,
            default: []
        },
        PichiTunnelBase: {
            type: Array,
            default: []
        },
        PichiTunnelCompare: {
            type: Array,
            default: []
        },
        PT1Tabs: {
            type: Object,
            default: {
                data: [], index: 999 // 選択されたタブの添字
            }
        },
        PT2Search: {
            type: Object,
            default: {}
        },
        PT2SearchTmp: {
            type: Object,
            default: {}
        },
        PT2HomeBallContent: {
            type: Object,
            default: {
                selectedZone: [],
                renderBall1: [],
                renderBall2: [],
                thresholdBall2: [],
                dataLoadFlag: false,
            }
        },
        PT2ChangeAmountThresholdSeekBar: {
            type: Object,
            default: {
                ptX: 14.6, // PT円の横幅
                ptY: 14.6, // PT円の縦幅
                hpY: 51.1, // HP円の縦幅
                hpX: 51.1, // HP円の横幅
                ptMaxUp: 29.2, //PT上限値の上の方
                ptMaxDown: 3.65, // PT上限値の下の方
                hpMaxUp: 51.1, // HP上限値の上の方
                hpMaxDown: 10.95, // HP上限値の下の方
                hpDepth: 100,// HP奥行
                ptDepth: 100,// PT奥行
                ptTime: 175, // PT初期値
                cx: 0, // 円x初期値
                cy: 0, //円y初期値
                ptDepthCheck: false, // pt奥行絞り込チェックボックス
                hpDepthCheck: false, // hp奥行絞り込チェックボックス
            }
        },
        PT2ConfirmationChangeAmountBall1: {
            type: Array,
            default: []
        }, PT2ConfirmationChangeAmountBall2: {
            type: Array,
            default: []
        }, PT2S1ThresholdSeekBar: {
            type: Object,
            default: {
                ptX: 14.6, // PT円の横幅
                ptY: 14.6, // PT円の縦幅
                hpY: 51.1, // HP円の縦幅
                hpX: 51.1, // HP円の横幅
                ptMaxUp: 29.2, //PT上限値の上の方
                ptMaxDown: 3.65, // PT上限値の下の方
                hpMaxUp: 51.1, // HP上限値の上の方
                hpMaxDown: 10.95, // HP上限値の下の方
                hpDepth: 100,// HP奥行
                ptDepth: 100,// PT奥行
                pt: 175, // PT初期値
                cx: 0, // 円x初期値
                cy: 0, //円y初期値
                ptDepthCheck: false, // pt奥行絞り込チェックボックス
                hpDepthCheck: false, // hp奥行絞り込チェックボックス
            }
        }, PT2SSelectedBall1: {
            type: Array,
            default: [],
        }, PT2SSelectedBall2: {
            type: Array,
            default: [],
        }, PT3from: {
            type: Object,
            default: {
                source: '', // Sなら閾値、Hなら変化量
            }
        }, FromPT2: false,
    }
}).$mount('#app')
